
import React from 'react';
import DigitalClock from './DigitalClock.tsx';

const Header: React.FC = () => {
  return (
    <header className="w-full max-w-5xl mx-auto py-6 flex justify-between items-center border-b-2 border-neon-cyan/30">
      <h1 className="text-2xl md:text-3xl font-black tracking-widest text-neon-purple neon-text-purple">
        GRISHA-14
      </h1>
      <DigitalClock />
    </header>
  );
};

export default Header;
